/* Style Mobo — Track Order page */
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-sm-track]');
  if (!root) return;

  const workerUrl = (root.dataset.workerUrl || '').replace(/\/$/, '');
  let courierLogos = {};
  try { courierLogos = JSON.parse(root.dataset.courierLogos || '{}'); } catch { courierLogos = {}; }

  function courierLogoUrl(carrierName) {
    const key = (carrierName || '').trim().toLowerCase();
    if (courierLogos[key]) return courierLogos[key];
    const match = Object.keys(courierLogos).find(k => key.includes(k));
    return match ? courierLogos[match] : null;
  }
  const tabs = root.querySelectorAll('[data-sm-track-tab]');
  const forms = root.querySelectorAll('[data-sm-track-form]');
  const phoneForm = root.querySelector('[data-sm-track-form="phone"]');
  const identifierForm = root.querySelector('[data-sm-track-form="identifier"]');
  const resultEl = root.querySelector('[data-sm-track-result]');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.smTrackTab;
      tabs.forEach(t => {
        const active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', String(active));
      });
      forms.forEach(f => {
        f.hidden = f.dataset.smTrackForm !== target;
      });
      resultEl.hidden = true;
      resultEl.innerHTML = '';
    });
  });

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = String(str == null ? '' : str);
    return div.innerHTML;
  }

  /* Shipmozo's two endpoints format status text differently — Track-Order
     returns human text ("Pickup Pending"), Get-Order-Detail returns
     SNAKE_CASE codes ("NEW_ORDER"). Normalize the latter for display. */
  function formatStatusText(status) {
    const s = (status || '').trim();
    if (!s) return '';
    if (/^[A-Z0-9_]+$/.test(s)) {
      return s.split('_').map(w => w.charAt(0) + w.slice(1).toLowerCase()).join(' ');
    }
    return s;
  }

  function statusHeadingClass(status) {
    const s = (status || '').toLowerCase();
    if (s.includes('deliver')) return 'sm-track__card-status-heading--delivered';
    if (s.includes('transit') || s.includes('out for') || s.includes('picked')) return 'sm-track__card-status-heading--transit';
    return 'sm-track__card-status-heading--default';
  }

  function isCod(paymentType) {
    return /cod|cash/i.test(paymentType || '');
  }

  /* Milestone progress bar — happy path is Placed -> Packed -> Ready to
     Ship -> Picked Up -> In Transit -> Out for Delivery -> Delivered.
     "Packed" / "Ready to Ship" aren't Shopify order statuses (Shopify only
     has fulfillment_status: unfulfilled/fulfilled) — they come from
     Shipmozo's own status feed if/when it reports a pre-pickup manifest
     event, so those two stages simply never light up for stores that
     don't get that signal. Cancelled/RTO orders branch off into their own
     short, 2-step bar instead of pretending they're still heading toward
     delivery. */
  const MILESTONE_ICONS = {
    placed: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>',
    packed: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/></svg>',
    ready: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M9 12l2 2 4-4"/></svg>',
    picked: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="7" width="13" height="9"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="5.5" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/></svg>',
    transit: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="7" width="13" height="9"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="5.5" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/></svg>',
    outfordelivery: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>',
    delivered: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 12l3 3 5-6"/></svg>',
    cancelled: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M15 9l-6 6M9 9l6 6"/></svg>',
    rto: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 4 3 9 8 9"/></svg>',
  };

  const HAPPY_PATH = [
    { key: 'placed', label: 'Order Placed' },
    { key: 'packed', label: 'Packed' },
    { key: 'ready', label: 'Ready to Ship' },
    { key: 'picked', label: 'Picked Up' },
    { key: 'transit', label: 'In Transit' },
    { key: 'outfordelivery', label: 'Out for Delivery' },
    { key: 'delivered', label: 'Delivered' },
  ];

  function resolveMilestoneState(status) {
    const s = (status || '').toLowerCase();
    if (s.includes('cancel')) return { branch: 'cancelled', label: 'Cancelled', note: 'This order was cancelled.' };
    if (s.includes('rto') || s.includes('return') || s.includes('undeliver')) {
      return { branch: 'rto', label: 'Returned to Origin', note: 'This shipment is being returned to us.' };
    }
    let note = '';
    if (s.includes('attempt') || s.includes('reschedul')) note = 'A delivery attempt was made and the order has been rescheduled.';

    /* "pick" alone is ambiguous — Shipmozo's own documented example status
       is "Pickup Pending", which means NOT yet picked up. Checked before
       the generic pick match, and pending is explicitly excluded from it,
       so a still-pending pickup doesn't jump the bar forward. */
    let stage = 0;
    if (s.includes('deliver') && !s.includes('out for')) stage = 6;
    else if (s.includes('out for')) stage = 5;
    else if (s.includes('transit')) stage = 4;
    else if (s.includes('ready to ship') || s.includes('ready for pickup') || s.includes('manifest')) stage = 2;
    else if (s.includes('pick') && !s.includes('pending')) stage = 3;
    else if (s.includes('pack')) stage = 1;
    return { branch: 'happy', stage, note };
  }

  function renderMilestones(tracking) {
    const state = resolveMilestoneState(tracking.current_status);

    let steps;
    if (state.branch === 'happy') {
      steps = HAPPY_PATH.map((m, i) => ({
        icon: MILESTONE_ICONS[m.key],
        label: m.label,
        complete: i < state.stage,
        current: i === state.stage,
      }));
    } else {
      steps = [
        { icon: MILESTONE_ICONS.placed, label: 'Order Placed', complete: true, current: false },
        { icon: MILESTONE_ICONS[state.branch], label: state.label, complete: false, current: true, danger: true },
      ];
    }

    const n = steps.length;
    const trackLeft = (0.5 / n) * 100;
    const trackWidth = 100 - (1 / n) * 100;
    const activeIndex = state.branch === 'happy' ? state.stage : n - 1;
    const fillWidth = n > 1 ? trackWidth * (activeIndex / (n - 1)) : 0;
    const fillClass = state.branch !== 'happy' ? ' sm-track__milestones-track-fill--danger' : '';

    const itemsHtml = steps.map(s => `
      <div class="sm-track__milestone${s.complete ? ' is-complete' : ''}${s.current ? ' is-current' : ''}${s.danger ? ' is-danger' : ''}">
        <span class="sm-track__milestone-icon">${s.icon}</span>
        <span class="sm-track__milestone-label">${escapeHtml(s.label)}</span>
      </div>
    `).join('');

    return `
      <div class="sm-track__milestones-wrap">
        <div class="sm-track__milestones-track" style="left:${trackLeft}%;width:${trackWidth}%;"></div>
        <div class="sm-track__milestones-track-fill${fillClass}" style="left:${trackLeft}%;width:${Math.max(0, fillWidth)}%;"></div>
        <div class="sm-track__milestones">${itemsHtml}</div>
      </div>
      ${state.note ? `<p class="sm-track__milestones-note${state.branch !== 'happy' ? ' sm-track__milestones-note--danger' : ''}">${escapeHtml(state.note)}</p>` : ''}
    `;
  }

  function formatDate(str) {
    if (!str) return '';
    const d = new Date(str.replace(' ', 'T'));
    if (isNaN(d.getTime())) return str;
    return d.toLocaleString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit' });
  }

  function renderOrderList(orders) {
    const itemsHtml = orders.map(order => `
      <button type="button" class="sm-track__list-item" data-sm-track-order="${escapeHtml(order.name)}">
        <div>
          <div class="sm-track__list-item-name">${escapeHtml(order.name)}</div>
          <div class="sm-track__list-item-date">${escapeHtml(formatDate(order.createdAt))}</div>
        </div>
        <span class="sm-track__list-item-status">${escapeHtml((order.status || '').replace(/_/g, ' '))}</span>
      </button>
    `).join('');

    resultEl.innerHTML = `
      <p class="sm-track__list-hint">Select an order to see its tracking status</p>
      <div class="sm-track__list">${itemsHtml}</div>
    `;
    resultEl.hidden = false;

    resultEl.querySelectorAll('[data-sm-track-order]').forEach(btn => {
      btn.addEventListener('click', () => {
        fetchAndRenderTracking(`identifier=${encodeURIComponent(btn.dataset.smTrackOrder)}`);
      });
    });
  }

  function renderTracking(tracking) {
    const scans = (tracking.status_feed && tracking.status_feed.scan) || [];
    const sorted = [...scans].sort((a, b) => new Date(b.date) - new Date(a.date));
    const latestDate = sorted[0] ? formatDate(sorted[0].date) : '';

    const timelineHtml = sorted.map(scan => `
      <div class="sm-track__scan">
        <div class="sm-track__scan-rail">
          <span class="sm-track__scan-dot"></span>
          <span class="sm-track__scan-line"></span>
        </div>
        <div class="sm-track__scan-content">
          <div class="sm-track__scan-status">${escapeHtml(scan.status)}</div>
          <div class="sm-track__scan-location">${escapeHtml(scan.location)}</div>
          <div class="sm-track__scan-date">${escapeHtml(formatDate(scan.date))}</div>
        </div>
      </div>
    `).join('') || '<p class="sm-track__list-hint">No tracking scans yet.</p>';

    const cod = isCod(tracking.payment_type);
    const paymentHtml = cod
      ? `<div class="sm-track__card-info-payment-value">COD</div><div class="sm-track__card-info-amount">₹${escapeHtml(tracking.cod_amount != null ? tracking.cod_amount : '—')}</div>`
      : `<div class="sm-track__card-info-payment-value">Prepaid</div>`;

    const logoUrl = courierLogoUrl(tracking.carrier);
    const carrierHtml = logoUrl
      ? `<img class="sm-track__card-carrier-logo" src="${escapeHtml(logoUrl)}" alt="${escapeHtml(tracking.carrier || '')}">`
      : `<div class="sm-track__card-carrier">${escapeHtml(tracking.carrier || '')}</div>`;

    resultEl.innerHTML = `
      <div class="sm-track__card">
        <div class="sm-track__card-head">
          <div>
            <div class="sm-track__card-label">Tracking No.</div>
            <div class="sm-track__card-awb">#${escapeHtml(tracking.awb_number || '—')}</div>
            ${tracking.order_id ? `<div class="sm-track__card-order-id">Order ID: #${escapeHtml(tracking.order_id)}</div>` : ''}
          </div>
          ${carrierHtml}
        </div>

        <div class="sm-track__card-status-row">
          <div>
            <div class="sm-track__card-status-label">${tracking.customer_name ? `${escapeHtml(tracking.customer_name.split(' ')[0])}, ` : ''}your order is</div>
            <div class="sm-track__card-status-heading ${statusHeadingClass(tracking.current_status)}">${escapeHtml(formatStatusText(tracking.current_status) || 'Processing')}</div>
            ${latestDate ? `<div class="sm-track__card-status-date">as on ${escapeHtml(latestDate)}</div>` : ''}
          </div>
          <div class="sm-track__card-info-box">
            <div class="sm-track__card-info-label">Payment Method</div>
            ${paymentHtml}
          </div>
        </div>

        ${renderMilestones(tracking)}

        <div class="sm-track__card-divider"></div>
        <div class="sm-track__timeline-heading">Tracking History</div>
        <div class="sm-track__timeline">${timelineHtml}</div>
      </div>
    `;
    resultEl.hidden = false;
  }

  function renderError(message) {
    resultEl.innerHTML = `<div class="sm-track__error">${escapeHtml(message)}</div>`;
    resultEl.hidden = false;
  }

  function renderLoading() {
    resultEl.innerHTML = `
      <div class="sm-track__skeleton">
        <div class="sm-track__skeleton-row">
          <div>
            <div class="sm-track__skel sm-track__skel--label"></div>
            <div class="sm-track__skel sm-track__skel--awb"></div>
          </div>
          <div class="sm-track__skel sm-track__skel--carrier"></div>
        </div>
        <div class="sm-track__skeleton-row">
          <div>
            <div class="sm-track__skel sm-track__skel--status-label"></div>
            <div class="sm-track__skel sm-track__skel--status"></div>
            <div class="sm-track__skel sm-track__skel--date"></div>
            <div class="sm-track__skel sm-track__skel--updated"></div>
          </div>
          <div class="sm-track__skel sm-track__skel--box"></div>
        </div>
        <div class="sm-track__skeleton-divider"></div>
        <div class="sm-track__skel sm-track__skel--history-heading"></div>
        ${[0, 1, 2].map(() => `
          <div class="sm-track__skeleton-scan">
            <div class="sm-track__skel sm-track__skel--dot"></div>
            <div class="sm-track__skeleton-scan-content">
              <div class="sm-track__skel sm-track__skel--scan-status"></div>
              <div class="sm-track__skel sm-track__skel--scan-location"></div>
              <div class="sm-track__skel sm-track__skel--scan-date"></div>
            </div>
          </div>
        `).join('')}
      </div>
    `;
    resultEl.hidden = false;
  }

  async function fetchAndRenderTracking(queryString) {
    renderLoading();
    try {
      const res = await fetch(`${workerUrl}/track?${queryString}`);
      const data = await res.json();
      if (!res.ok) {
        renderError(data.error || 'Something went wrong. Please try again.');
        return;
      }
      renderTracking(data.tracking);
    } catch {
      renderError('Something went wrong. Please check your connection and try again.');
    }
  }

  async function withSubmitLock(form, task) {
    if (!workerUrl) {
      renderError('Tracking service is not configured yet.');
      return;
    }
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    try {
      await task();
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  if (phoneForm) {
    phoneForm.addEventListener('submit', e => {
      e.preventDefault();
      const phone = phoneForm.querySelector('#sm-track-phone').value.trim();
      withSubmitLock(phoneForm, async () => {
        renderLoading();
        try {
          const res = await fetch(`${workerUrl}/track?phone=${encodeURIComponent(phone)}`);
          const data = await res.json();
          if (!res.ok) {
            renderError(data.error || 'Something went wrong. Please try again.');
            return;
          }
          renderOrderList(data.orders);
        } catch {
          renderError('Something went wrong. Please check your connection and try again.');
        }
      });
    });
  }

  if (identifierForm) {
    identifierForm.addEventListener('submit', e => {
      e.preventDefault();
      const identifier = identifierForm.querySelector('#sm-track-identifier').value.trim();
      withSubmitLock(identifierForm, () =>
        fetchAndRenderTracking(`identifier=${encodeURIComponent(identifier)}`)
      );
    });
  }
});
